import { render, staticRenderFns } from "./roast.vue?vue&type=template&id=d27232a8&"
import script from "./roast.vue?vue&type=script&lang=js&"
export * from "./roast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports